import api, { handleApiError } from './client';

export const settingsService = {
  getSettings: async () => {
    try {
      const response = await api.get('/api/settings');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get settings error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nel caricamento delle impostazioni')
      };
    }
  },

  createSetting: async (key, value, description = null) => {
    try {
      await api.post('/api/settings', { key, value, description });
      return {
        success: true,
        message: 'Impostazione creata con successo'
      };
    } catch (error) {
      console.error('Create setting error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nella creazione dell'impostazione")
      };
    }
  },

  updateSetting: async (key, value, description = null) => {
    try {
      await api.put('/api/settings', { key, value, description });
      return {
        success: true,
        message: 'Impostazione aggiornata con successo'
      };
    } catch (error) {
      console.error('Update setting error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'aggiornamento dell'impostazione")
      };
    }
  },

  getReminderLogs: async (page = 1, limit = 20) => {
    try {
      const response = await api.get('/api/settings/reminder-logs', {
        params: { page, limit }
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get reminder logs error:', error);
      return {
        success: false,
        message: handleApiError(error, 'Errore nel caricamento dei log')
      };
    }
  },

  sendTestReminder: async () => {
    try {
      const response = await api.post('/api/settings/test-subscription-reminder');
      return {
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      console.error('Send test reminder error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'invio dell'email di test")
      };
    }
  },

  sendTestPayPerUseReminder: async (reminderType) => {
    try {
      const response = await api.post('/api/settings/test-payperuse-reminder', { reminderType });
      return {
        success: response.data.success,
        message: response.data.message
      };
    } catch (error) {
      console.error('Send test pay-per-use reminder error:', error);
      return {
        success: false,
        message: handleApiError(error, "Errore nell'invio dell'email di test pay-per-use")
      };
    }
  }
};

export default settingsService;
